import { createORPCClient } from "@orpc/client"
import { RPCLink } from "@orpc/client/fetch"
import type { AppRouterClient } from "../../../backend/src/router"

export const backendUrl =
  import.meta.env.VITE_BACKEND_URL?.trim() ||
  (import.meta.env.DEV ? "http://localhost:3001" : "")

if (!backendUrl) {
  throw new Error("VITE_BACKEND_URL is required to use intoshort.")
}

const link = new RPCLink({
  url: `${backendUrl}/rpc`,
  fetch: (input, init) => fetch(input, { ...init, credentials: "include" }),
})

export const videoClient: AppRouterClient = createORPCClient(link)
